import apolloClient from "../../../shared/utilities/graphql/apolloClient";

export default {
  mutate: apolloClient.mutate
};
